import { Link } from "../tools";
import { Typography } from "@mui/material";
import * as React from "react";
import Menubar from "./Menubar";
import { Root, Panel, MainFrame, Content } from "./styles";

export default ({ children }: { children: React.ReactNode }) => {
    return (
        <Root>
            <Panel>
                <Link to="/">
                    <Typography variant="h4" noWrap style={{ color: "white" }} id="header-conference">
                        Conference
                    </Typography>
                </Link>
            </Panel>
            <Menubar />
            <MainFrame>
                <Content>{children}</Content>
            </MainFrame>
        </Root>
    );
};
